import clsx from "clsx";
import React from "react";
import { Search } from "./search";

interface Props {
  id?: string;
  className?: string;
  value: string;
  options: any[];

  handleOnChange: (evt: React.ChangeEvent<HTMLInputElement>) => void;
  handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  handleOnItemClick: (no: string) => void;
}

export const SearchWithOption: React.FC<Props> = (props) => {
  const {
    id = "",
    className = "",
    value,
    options,
    handleKeyDown,
    handleOnChange,
    handleOnItemClick,
  } = props;

  const [isOpen, open] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);

  const handleOnFocus = () => {
    if (ref.current) {
      ref.current.style.maxHeight = `150px`;
    }
    open(true);
  };

  const handleOnBlur = () => {
    if (ref.current) {
      ref.current.style.maxHeight = "0";
    }
    open(false);
  };

  return (
    <div id={id} className={className}>
      <Search
        type="text"
        placeholder="Search.."
        value={value}
        onChange={handleOnChange}
        onKeyDown={handleKeyDown}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
      />
      <div className={clsx("dropdown-content", { open: isOpen })} ref={ref}>
        {options.map((row: any) => (
          <div
            className="item"
            onClick={() => {
              handleOnItemClick(row.no);
            }}
            key={row.no}
          >
            {row.no}
          </div>
        ))}
      </div>
    </div>
  );
};
